import React from 'react';

import PropTypes from 'prop-types';

import { StarFullIcon } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './CarrierRating.scss';

const propTypes = {
    rating: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
};

function getRatingFormatted(ratingRaw) {
    return parseFloat(ratingRaw, 10);
}

function CarrierRating(props) {
    const {
        rating,
        text,
        i18nNumber,
    } = props;

    const ratingLabel = getRatingFormatted(rating);
    const localizedRatingLabel = i18nNumber(ratingLabel)
        .format('decimal', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    return (
        <span className={styles.carrierRating}>
            <StarFullIcon className={styles.star} />
            <span className={styles.text}>
                {localizedRatingLabel}
                <span className={styles.starsText}>{text}</span>
            </span>
        </span>
    );
}

CarrierRating.propTypes = propTypes;

export { CarrierRating };
export default localize(CarrierRating);
